import {
  Component,
  Input,
  OnInit,
  Output,
  EventEmitter,
  ViewChild,
} from '@angular/core';
import { FormBuilder, UntypedFormGroup } from '@angular/forms';
import { faTimes, faPlus, faSave } from '@fortawesome/free-solid-svg-icons';
import { RegexSearchModalComponent } from '../regex-search-modal/regex-search-modal.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-promotion-code-form',
    templateUrl: './promotion-code-form.component.html',
    styleUrls: ['./promotion-code-form.component.scss'],
    standalone: false
})
export class PromotionCodeFormComponent implements OnInit {
  @Input() promoCodeFormModel: any;
  @Input() index: any;
  @Input() promoCode: any;
  @Input() defaultPromoCode: any;
  @Output() promoCodeEvent = new EventEmitter();
  promoCodeForm: UntypedFormGroup;
  originalPromotionCode: string;
  faTimes = faTimes;
  faPlus = faPlus;
  faSave = faSave;
  @ViewChild(RegexSearchModalComponent) regexSearchModalComponent: RegexSearchModalComponent;

  constructor(
    private formBuilder: FormBuilder,
    private modalHelper: NgbModal
  ) {}

  ngOnInit(): void {
    if (this.index !== null) {
      this.promoCodeForm = this.formBuilder.group({
        promotionCode: [this.promoCodeFormModel.promotionCode],
      });
      this.originalPromotionCode = this.promoCodeFormModel.promotionCode;
    } else {
      this.promoCodeForm = this.formBuilder.group({
        promotionCode: [this.defaultPromoCode || ''],
      });
    }
  }

  emitEvent(type: string, index?: number): void {
    const value = this.promoCodeForm.value;
    this.promoCodeEvent.emit({ type, index, value });
    if (type === 'add') {
      this.promoCodeForm.reset();
    }
  }

  resetEdit(): void {
    this.promoCodeForm.controls.promotionCode.setValue(
      this.originalPromotionCode
    );
  }

  regexSearchModal(
    searchFor: string,
    item: any,
    size: string,
    limitToOne: boolean,
    setValue: boolean,
    itemIndex: number
  ): void {
    this.openRegexSearchModal(
      searchFor,
      item,
      size,
      limitToOne,
      setValue,
      itemIndex
    );
  }

  openRegexSearchModal(
    searchFor: string,
    item: any,
    size: string,
    limitToOne: boolean,
    setValue: boolean,
    itemIndex: number
  ): void {
    const instance = this.modalHelper.open(RegexSearchModalComponent);
    instance.componentInstance.searchFor = searchFor;
    instance.componentInstance.item = item;
    instance.componentInstance.size = size;
    instance.componentInstance.limitToOne = limitToOne;
    instance.componentInstance.setValue = setValue;
    instance.componentInstance.itemIndex = itemIndex;
    instance.componentInstance.successEvent.subscribe((text: any) => {
      this.promoCodeForm.patchValue({ promotionCode: item?.object?.code });
      instance.close();
    });
  }
}
